module.exports = __webpack_public_path__ + "static/media/details2.9fcfb454.svg";